import { Component, inject, signal } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { BranchDetailsComponents } from '../new-rep-application-section/branch-details/branch-details.components';
import { PersonalDetailsComponent } from '../new-rep-application-section/personal-details/personal-details.component';
import { SpouseDetailsComponent } from '../new-rep-application-section/spouse-details/spouse-details.component';
import { ContactDetailsComponent } from '../new-rep-application-section/contact-details/contact-details.component';
import { BankDetailsComponent } from '../new-rep-application-section/bank-details/bank-details.component';
import { ServiceCommitmentComponent } from '../new-rep-application-section/service-commitment/service-commitment.component';
import { AcademicQualificationsComponent } from '../new-rep-application-section/academic-qualifications/academic-qualifications.component';
import { BusinessInterestsComponent } from '../new-rep-application-section/business-interests/business-interests.component';
import { GeneralInformationComponent } from "../new-rep-application-section/general-information/general-information.component";
import { FitPropercriteriaComponent } from "../new-rep-application-section/fit-propercriteria/fit-propercriteria.component";
import { AdditionalDeclarationsComponent } from '../new-rep-application-section/additional-declarations/additional-declarations.component';
import { DeclarationClausesComponent } from '../new-rep-application-section/declaration-clauses/declaration-clauses.component';
import { RegulatoryProfessionalQualificationsComponent } from '../new-rep-application-section/regulatory-professional-qualifications/regulatory-professional-qualifications.component';
import { EmploymentHistoryComponent } from '../new-rep-application-section/employment-history/employment-history.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { NewRepApplicationService } from '../new-rep-application-services/new-rep-application.service';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { CommonModule, formatDate } from '@angular/common';
import { NewRepApplication } from '../new-rep-application-models/new-rep-application.model';
import { ViewNewRepApplication } from '../new-rep-application-interfaces/viewnew-rep-application.interface';
import { viewChecklist } from '../new-rep-application-interfaces/checklist.interface';
import { Attachements, viewAttachements } from '../new-rep-application-interfaces/attachements.interface';
import { viewEmploymentHistory } from '../new-rep-application-interfaces/employmenthistory.interface';
import { allQualifications } from '../new-rep-application-interfaces/qualifications.interface';
import { AdditionalAttachmentsComponent } from '../new-rep-application-section/additional-attachments/additional-attachments.component';
import { UserAuthenticationService } from '../../../../core/services/user-authentication/user-authentication.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { DocumentPreviewOverlayDirective } from '../../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';


export interface OnboardingSection {
  id: string;
  title: string;
  icon: string;
  completed: boolean;
  expanded: boolean;
}
@Component({
  selector: 'app-new-rep-application',
  imports: [
    CommonModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatIcon,
    MatButtonModule,
    // PiasLayoutComponent,
    BranchDetailsComponents,
    PersonalDetailsComponent,
    SpouseDetailsComponent,
    ContactDetailsComponent,
    BankDetailsComponent,
    ServiceCommitmentComponent,
    AcademicQualificationsComponent,
    RegulatoryProfessionalQualificationsComponent,
    EmploymentHistoryComponent,
    BusinessInterestsComponent,
    GeneralInformationComponent,
    FitPropercriteriaComponent,
    AdditionalDeclarationsComponent,
    AdditionalAttachmentsComponent,
    DeclarationClausesComponent,
    DocumentPreviewOverlayDirective,
  ],
  templateUrl: './new-rep-application.page.html',
  styleUrl: './new-rep-application.page.scss'
})
export class NewRepApplicationPage {
  onboardingForm!: FormGroup;
  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private sessionStorageService = inject(SessionStorageService);
  private userAuthenticationService = inject(UserAuthenticationService);
  private newRepApplicationService = inject(NewRepApplicationService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);
  setSprinner = signal(false);
  currentStep = 0;
  branchDetailsFormValid = signal('Not Started');
  personalDetailsFormValid = signal('Not Started');
  spouseDetailsFormValid = signal('Not Started');
  contactDetailsFormValid = signal('Not Started');
  bankDetailsFormValid = signal('Not Started');
  serviceCommitmentFormValid = signal('Not Started');
  academicFormValid = signal('Not Started');
  regulatoryProfessionalQualificationsFormValid = signal('Not Started');
  employmentHistoryFormValid = signal('Not Started');
  businessInterestsFormValid = signal('Not Started');
  generalInformationFormValid = signal('Not Started');
  fitandProperCriteriaFormValid = signal('Not Started');
  additionalDeclarationsFormValid = signal('Not Started');
  additionalAttachmentsFormValid = signal('Not Started');
  declarationClausesFormValid = signal('Not Started');
  acknowledgementFormFormValid = signal('Not Started');
  maritalStatus = '';
  protected viewApplicationdetails!: ViewNewRepApplication;
  protected viewCheckList!: viewChecklist[];
  protected viewattachments!: viewAttachements[];
  protected viewemployementhistory!: viewEmploymentHistory[];
  protected viewAllqualification!: allQualifications[];
  protected viewacdamicqualification: allQualifications[] = [];
  protected viewprofessionalqualification: allQualifications[] = [];
  protected viewbusinessintersts: viewChecklist[] = [];
  protected viewgeneralinformation: viewChecklist[] = [];
  protected viewfitpropercriteria: viewChecklist[] = [];
  submitmessage = '';
  finalsubmit = signal(false);

  protected currentUserRole: string = "";

  viewId!: number;
  data = history.state;
  checkStatus!: string;

  constructor() { }
  isReadOnly = signal(false);
  selectedDocument!: SafeResourceUrl;
  isPdf = false;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;
  showPreview = false;
  currentFileName!: string;

  ngOnInit() {
    this.buildForm();
    // this.applyReadOnly(); 
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    if (this.currentUserRole == 'NEWREP') {
      this.viewId = Number(this.sessionStorageService.getCurrentUserId());
      this.viewApplication();
    } else {
      this.viewId = this.data.id;
      this.viewApplication();
      this.isReadOnly.set(true);
    }
  }

  buildForm() {

    this.onboardingForm = this.fb.group({

      branchDetails: this.fb.group({
      }),

      personalDetails: this.fb.group({}),

      spouseDetails: this.fb.group({}),

      contactDetails: this.fb.group({}),

      bankDetails: this.fb.group({}),

      serviceCommitment: this.fb.group({}),

      academic: this.fb.group({}),

      regulatoryProfessionalQualifications: this.fb.group({}),

      employmentHistory: this.fb.group({}),

      businessInterests: this.fb.group({}),

      generalInformation: this.fb.group({}),

      fitandProperCriteria: this.fb.group({}),

      additionalDeclarations: this.fb.group({}),

      additionalAttachments: this.fb.group({}),

      declarationClauses: this.fb.group({}),

      // acknowledgementForm: this.fb.group({})

    });

  }



  get branchDetailsForm(): FormGroup {
    return this.onboardingForm.get('branchDetails') as FormGroup;
  }

  get personalDetailsForm(): FormGroup {
    return this.onboardingForm.get('personalDetails') as FormGroup;
  }
  get spouseDetailsForm(): FormGroup {
    return this.onboardingForm.get('spouseDetails') as FormGroup;
  }
  get contactDetailsForm(): FormGroup {
    return this.onboardingForm.get('contactDetails') as FormGroup;
  }
  get bankDetailsForm(): FormGroup {
    return this.onboardingForm.get('bankDetails') as FormGroup;
  }
  get serviceCommitment(): FormGroup {
    return this.onboardingForm.get('serviceCommitment') as FormGroup;
  }
  get academic(): FormGroup {
    return this.onboardingForm.get('academic') as FormGroup;
  }

  get regulatoryProfessionalQualifications(): FormGroup {
    return this.onboardingForm.get('regulatoryProfessionalQualifications') as FormGroup;
  }

  get employmentHistory(): FormGroup {
    return this.onboardingForm.get('employmentHistory') as FormGroup;
  }

  get businessInterests(): FormGroup {
    return this.onboardingForm.get('businessInterests') as FormGroup;
  }

  get generalInformation(): FormGroup {
    return this.onboardingForm.get('generalInformation') as FormGroup;
  }

  get fitandProperCriteria(): FormGroup {
    return this.onboardingForm.get('fitandProperCriteria') as FormGroup;
  }

  get additionalDeclarations(): FormGroup {
    return this.onboardingForm.get('additionalDeclarations') as FormGroup;
  }

  get additionalAttachments(): FormGroup {
    return this.onboardingForm.get('additionalAttachments') as FormGroup;
  }

  get declarationClauses(): FormGroup {
    return this.onboardingForm.get('declarationClauses') as FormGroup;
  }
  get acknowledgementForm(): FormGroup {
    return this.onboardingForm.get('acknowledgementForm') as FormGroup;
  }

  changeIndex(index: number) {
    this.currentStep = index;
  }

  async viewApplication() {
    this.setSprinner.set(true);
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewApplicationdetails = responseData.data.responsedata.NewRepData;
      this.checkStatus = this.viewApplicationdetails?.status;
      // Seed the marital status from the saved application. The spouse section
      // derives its badge from this input, and on a reload it used to arrive
      // empty until the applicant re-picked the radio - so a married candidate
      // came back with the spouse section reading as if nothing were required.
      this.maritalStatus = this.viewApplicationdetails?.maritalStatus ?? '';
      if (['Candidate Submission', 'Candidate Update (Due Diligence)', 'Candidate Update (Assessment)'].includes(this.checkStatus)) {
        if (this.currentUserRole !== 'NEWREP') {
          this.isReadOnly.set(true);
        } else {
          this.isReadOnly.set(false);
        }
      } else {
        this.isReadOnly.set(true);
        // if (this.currentUserRole === 'NEWREP') {
        //   const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
        //     width: '500px',
        //     disableClose: true,
        //     data: {
        //       message: 'Your Application has been successfully submitted. Currently in Review. No further action required.',
        //       hidecancel: true,
        //     }
        //   });

        //   dialogRef.afterClosed().subscribe(async result => {
        //     if (result.data === true) {
        //       const responseData = await this.userAuthenticationService.userLogout()
        //         .then((response) => {
        //           return JSON.parse(response);
        //         })
        //         .catch((error) => {
        //           // console.error(error);
        //           return error;
        //         });

        //       // Handling the response from the API call.
        //       if (responseData.status === HttpStatusCode.Ok) {
        //         // Display notification on successful logout.
        //         this.snackBarService.openSuccessSnackBar("Logged out successfully!");
        //       } else {
        //         // Display notification on logout failure.
        //         this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
        //       }

        //       this.sessionStorageService.clearSessionStorage();
        //       this.router.navigate(['/login'])
        //     }
        //   });
        // }

      }
      this.viewCheckList = responseData.data.responsedata.Checklist;
      this.viewemployementhistory = responseData.data.responsedata.employment_history;
      this.viewAllqualification = responseData.data.responsedata.professional_qualification;
      this.viewattachments = responseData.data.responsedata.attachments;
      this.viewacdamicqualification = this.viewAllqualification.filter(academic => academic.categoryName.includes('ACADEMIC'));
      this.viewprofessionalqualification = this.viewAllqualification.filter(professional => professional.categoryName.includes('PROFESSIONAL'));
      this.viewbusinessintersts = this.viewCheckList.filter(business => business.categoryName.includes('businessInterests_'))
        .sort((a, b) => {
          const aIndex = Number(a.categoryName.split('_').pop());
          const bIndex = Number(b.categoryName.split('_').pop());
          return aIndex - bIndex;
        });
      this.viewgeneralinformation = this.viewCheckList.filter(generalInformation => generalInformation.categoryName.includes('generalInformation_'))
        .sort((a, b) => {
          const aIndex = Number(a.categoryName.split('_').pop());
          const bIndex = Number(b.categoryName.split('_').pop());
          return aIndex - bIndex;
        });
      this.viewfitpropercriteria = this.viewCheckList.filter(fit => fit.categoryName.includes('fitPropercriteria_'))
        .sort((a, b) => {
          const aIndex = Number(a.categoryName.split('_').pop());
          const bIndex = Number(b.categoryName.split('_').pop());
          return aIndex - bIndex;
        });
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  /**
   * @param sectionIndex Position of the emitting section in `formValidators`, bound
   *   in the template. The badge has to be addressed by the section that reported it:
   *   every section loads its own data, so on a refresh the fifteen emits arrive in
   *   whatever order their requests happen to finish, and routing them through
   *   `currentStep` filed each status under whichever section the cursor had reached.
   */
  async onSectionNext(status: string[], sectionIndex: number) {

    const formValidators = [
      this.branchDetailsFormValid,
      this.personalDetailsFormValid,
      this.spouseDetailsFormValid,
      this.contactDetailsFormValid,
      this.bankDetailsFormValid,
      this.serviceCommitmentFormValid,
      this.academicFormValid,
      this.regulatoryProfessionalQualificationsFormValid,
      this.employmentHistoryFormValid,
      this.businessInterestsFormValid,
      this.generalInformationFormValid,
      this.fitandProperCriteriaFormValid,
      this.additionalDeclarationsFormValid,
      this.additionalAttachmentsFormValid,
      this.declarationClausesFormValid,
    ];

    // ✅ set current status
    formValidators[sectionIndex]?.set(status[0]);
    // The branches below stay on currentStep: they only run for the user-driven
    // 'submit' / 'finalsubmit' emits, where the cursor is the panel being saved.
    // Marital status follows the section that reported it, for the same reason
    // the badge does. Gating this on `currentStep` meant the radio only reached
    // the spouse section while the cursor happened to sit on Personal Details,
    // so picking "Single" before the panel advanced never updated its badge.
    if (sectionIndex === 1) {
      this.maritalStatus = this.personalDetailsForm.controls['maritalStatus']?.value ?? '';
    }
    if (status[1] === 'submitted') {
      this.currentStep++;
    }

    if ((status[0] === 'Completed' || status[0] === 'In Progress') && status[1] === 'submit') {
      if (![0, 14].includes(this.currentStep)) {
        let savenewApplication = new NewRepApplication();

        savenewApplication.setId(this.viewId);
        if (this.currentStep === 1) {

          savenewApplication.setFullNameNric(this.changeFullName(this.personalDetailsForm.get('fullName')?.value));
          savenewApplication.setPreferredName(this.changeFullName(this.personalDetailsForm.get('preferredName')?.value));
          savenewApplication.setNricNo(this.personalDetailsForm.get('nric')?.value);
          savenewApplication.setGender(this.personalDetailsForm.get('gender')?.value);
          const formatted = formatDate(
            this.personalDetailsForm.get('dob')?.value,
            'yyyy-MM-dd',
            'en-US'
          );
          savenewApplication.setDateOfBirth(formatted + 'T00:00:00Z');
          if (this.personalDetailsForm.get('nationality')?.value === 'others') {
            savenewApplication.setNationality([this.personalDetailsForm.get('nationality')?.value, this.personalDetailsForm.get('otherNationality')?.value].toString());
          } else if (this.personalDetailsForm.get('nationality')?.value === 'Singapore Permanent Resident') {
            savenewApplication.setNationality([this.personalDetailsForm.get('nationality')?.value, this.personalDetailsForm.get('otherNationality')?.value].toString());
          } else {
            savenewApplication.setNationality(this.personalDetailsForm.get('nationality')?.value);
          }
          savenewApplication.setPlaceOfBirth(this.personalDetailsForm.get('countryofbirth')?.value);
          savenewApplication.setFinPassportNo(this.personalDetailsForm.get('passport')?.value);
          if (this.personalDetailsForm.get('race')?.value === 'others') {
            savenewApplication.setRace(this.personalDetailsForm.get('raceSpecify')?.value);
          } else {
            savenewApplication.setRace(this.personalDetailsForm.get('race')?.value);
          }
          savenewApplication.setMaritalStatus(this.personalDetailsForm.get('maritalStatus')?.value);
        } else if (this.currentStep === 2) {
          savenewApplication.setSpouseNameNric(this.spouseDetailsForm.get('spouseName')?.value);
          savenewApplication.setSpouseNricNo(this.spouseDetailsForm.get('spousenric')?.value);
          if (this.spouseDetailsForm.get('spousedob')?.value) {
            const formatted = formatDate(
              this.spouseDetailsForm.get('spousedob')?.value,
              'yyyy-MM-dd',
              'en-US'
            );
            savenewApplication.setSpouseDob(formatted + 'T00:00:00Z');
          } else {
            savenewApplication.setSpouseDob(this.spouseDetailsForm.get('spousedob')?.value);
          }

          if (this.spouseDetailsForm.get('spouseNationality')?.value === 'others') {
            savenewApplication.setSpouseNationality([this.spouseDetailsForm.get('spouseNationality')?.value, this.spouseDetailsForm.get('spouseothernationality')?.value].toString());
          } else if (this.spouseDetailsForm.get('spouseNationality')?.value === 'Singapore Permanent Resident') {
            savenewApplication.setSpouseNationality([this.spouseDetailsForm.get('spouseNationality')?.value, this.spouseDetailsForm.get('spouseothernationality')?.value].toString());
          }
          else {
            savenewApplication.setSpouseNationality(this.spouseDetailsForm.get('spouseNationality')?.value);
          }
          savenewApplication.setSpouseFinPassportNo(this.spouseDetailsForm.get('spousefinorpassportno')?.value);
          savenewApplication.setSpouseOccuption(this.spouseDetailsForm.get('spouseoccupation')?.value);
          savenewApplication.setSpouseNameoftheemployer(this.spouseDetailsForm.get('spouseemployer')?.value);

        } else if (this.currentStep === 3) {
          const address = [this.contactDetailsForm.get('house')?.value,
          this.contactDetailsForm.get('street')?.value, this.contactDetailsForm.get('level')?.value, this.contactDetailsForm.get('building')?.value,
          this.contactDetailsForm.get('postalCode')?.value].toString();
          savenewApplication.setAddress(address);
          savenewApplication.setHomeNumber(this.contactDetailsForm.get('contactNumber')?.value);
          savenewApplication.setMobileNumber(this.contactDetailsForm.get('mobileNumber')?.value);
          savenewApplication.setPersonalEmailAddres(this.contactDetailsForm.get('personalEmailAddress')?.value);

        } else if (this.currentStep === 4) {
          savenewApplication.setBankname(this.bankDetailsForm.get('bankName')?.value);
          savenewApplication.setBankBranchName(this.bankDetailsForm.get('branchname')?.value);
          savenewApplication.setBankAccountNumber(this.bankDetailsForm.get('accountNumber')?.value);

        } else if (this.currentStep === 5) {
          savenewApplication.setServiceStatusNotApplicable(this.serviceCommitment.get('section')?.value);
          savenewApplication.setServiceStatus(this.serviceCommitment.get('status')?.value);
          savenewApplication.setEnlistmentDate(this.serviceCommitment.get('enlistment')?.value ? formatDate(this.serviceCommitment.get('enlistment')?.value, 'yyyy-MM', 'en-US') : '');
          savenewApplication.setOrdDate(this.serviceCommitment.get('ord')?.value ? formatDate(this.serviceCommitment.get('ord')?.value, 'yyyy-MM', 'en-US') : '');

        } else if (this.currentStep === 6) {
          const formArray = this.academic.get('academicqualifications') as FormArray;
          const academicqualifications = formArray.controls.map((control: any, index: number) => ({
            id: this.viewacdamicqualification[index]?.id == 0 ? 0 : this.viewacdamicqualification[index]?.id,
            onboardingRepId: this.viewId,
            category_name: 'ACADEMIC',
            qualification_type: control.get('qualification')?.value,
            institution_name: control.get('institution')?.value,
            start_date: control.get('startDate')?.value ? formatDate(control.get('startDate')?.value, 'yyyy-MM', 'en-US') : '',
            end_date: control.get('endDate')?.value ? formatDate(control.get('endDate')?.value, 'yyyy-MM', 'en-US') : '',
            has_transcript: control.get('transcriptfilecheck')?.value,
            has_certificate: control.get('certificatefilecheck')?.value,
          }));
          savenewApplication.setAcademicQualifications(academicqualifications);

        } else if (this.currentStep === 7) {
          savenewApplication.setm5_res5(this.regulatoryProfessionalQualifications.get('m5')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m5_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m5')?.value);
          savenewApplication.setm9(this.regulatoryProfessionalQualifications.get('m9')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m9_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m9')?.value);
          savenewApplication.setm8_rep(this.regulatoryProfessionalQualifications.get('m8')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m8_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m8')?.value);
          savenewApplication.setcbcp(this.regulatoryProfessionalQualifications.get('bcp')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('bcp_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('bcp')?.value);
          savenewApplication.setm6_rep(this.regulatoryProfessionalQualifications.get('m6')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m6_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m6')?.value);
          savenewApplication.setm9a(this.regulatoryProfessionalQualifications.get('m9a')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m9a_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m9a')?.value);
          savenewApplication.setm8a_rep(this.regulatoryProfessionalQualifications.get('m8a')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m8a_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m8a')?.value);
          savenewApplication.setpgi(this.regulatoryProfessionalQualifications.get('pgi')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('pgi_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('pgi')?.value);
          savenewApplication.setm6a_rep(this.regulatoryProfessionalQualifications.get('m6a')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('m6a_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('m6a')?.value);
          savenewApplication.setcm_lip(this.regulatoryProfessionalQualifications.get('lip')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('lip_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('lip')?.value);
          savenewApplication.setcm_cis(this.regulatoryProfessionalQualifications.get('cis')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('cis_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('cis')?.value);
          savenewApplication.setcommgi(this.regulatoryProfessionalQualifications.get('commgi')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('commgi_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('commgi')?.value);
          savenewApplication.setcm_cmp(this.regulatoryProfessionalQualifications.get('cmp')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('cmp_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('cmp')?.value);
          savenewApplication.sethi(this.regulatoryProfessionalQualifications.get('hi')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('hi_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('hi')?.value);
          savenewApplication.setcm_lic(this.regulatoryProfessionalQualifications.get('lic')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('lic_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('lic')?.value);
          savenewApplication.setcert_in_gi(this.regulatoryProfessionalQualifications.get('gi')?.value == 'yes' ? formatDate(this.regulatoryProfessionalQualifications.get('gi_Date')?.value, 'yyyy-MM-dd', 'en-US') : this.regulatoryProfessionalQualifications.get('gi')?.value);

          const formArray = this.regulatoryProfessionalQualifications.get('professionalqualifications') as FormArray;

          const professionalqualifications = formArray.controls.map((control: any, index: number) => ({
            id: this.viewprofessionalqualification[index]?.id == 0 ? 0 : this.viewprofessionalqualification[index]?.id,
            onboardingRepId: this.viewId,
            category_name: 'PROFESSIONAL',
            name_of_professional_body: control.get('professionalbody')?.value,
            professional_qualification: control.get('professionalQualification')?.value,
            attainment_date: control.get('dateofAttainment')?.value ? formatDate(control.get('dateofAttainment')?.value, 'yyyy-MM', 'en-US') : '',

          }));
          savenewApplication.setQualifications(professionalqualifications);

        } else if (this.currentStep === 8) {
          const formArray = this.employmentHistory.get('employementhistory') as FormArray;
          const employementHistory = formArray.controls.map((control: any, index: number) => ({

            id: this.viewemployementhistory[index]?.id == 0 ? 0 : this.viewemployementhistory[index]?.id,
            onboardingRepId: this.viewId,
            employer_name: control.get('employer')?.value,
            last_position_held: control.get('position')?.value,
            start_date: control.get('startDate')?.value ? formatDate(control.get('startDate')?.value, 'yyyy-MM', 'en-US') : '',
            end_date: control.get('endDate')?.value ? formatDate(control.get('endDate')?.value, 'yyyy-MM', 'en-US') : '',
            nature_of_employment: control.get('employment')?.value,
            reason_for_leaving: control.get('reason')?.value,
            employer_contact_details: control.get('email')?.value
          }));
          savenewApplication.setEmploymentHistory(employementHistory);

        } else if (this.currentStep === 9) {

          savenewApplication.setChecklist([
            {
              id: this.viewbusinessintersts[0]?.id == 0 ? 0 : this.viewbusinessintersts[0]?.id,
              category_name: 'businessInterests_1',
              is_completed: this.businessInterests.get('businessInterests_1')?.value,
              response_value: this.businessInterests.get('businessInterestsyes_1')?.value,
            },
            {
              id: this.viewbusinessintersts[1]?.id == 0 ? 0 : this.viewbusinessintersts[1]?.id,
              category_name: 'businessInterests_2',
              is_completed: this.businessInterests.get('businessInterests_2')?.value,
              response_value: this.businessInterests.get('businessInterestsyes_2')?.value,
            },
            {
              id: this.viewbusinessintersts[2]?.id == 0 ? 0 : this.viewbusinessintersts[2]?.id,
              category_name: 'businessInterests_3',
              is_completed: this.businessInterests.get('businessInterests_3')?.value,
              response_value: this.businessInterests.get('businessInterestsyes_3')?.value,
            },
            {
              id: this.viewbusinessintersts[3]?.id == 0 ? 0 : this.viewbusinessintersts[3]?.id,
              category_name: 'businessInterests_4',
              is_completed: this.businessInterests.get('businessInterests_4')?.value,
              response_value: this.businessInterests.get('businessInterestsyes_4')?.value,
            },
          ]);

        } else if (this.currentStep === 10) {
          let responsevalue1;
          if (this.generalInformation.get('generalInformation_1')?.value === true) {
            responsevalue1 = this.generalInformation.get('generalInformationyes_1')?.value;

          } else {
            responsevalue1 = this.generalInformation.get('generalInformationno_1')?.value;
            if (responsevalue1 === 'Others') {
              responsevalue1 = this.generalInformation.get('generalInformationno_1_others')?.value;
            }
          }
          savenewApplication.setChecklist([
            {
              id: this.viewgeneralinformation[0]?.id == 0 ? 0 : this.viewgeneralinformation[0]?.id,
              category_name: 'generalInformation_1',
              is_completed: this.generalInformation.get('generalInformation_1')?.value,
              response_value: responsevalue1,
            },
            {
              id: this.viewgeneralinformation[1]?.id == 0 ? 0 : this.viewgeneralinformation[1]?.id,
              category_name: 'generalInformation_2',
              is_completed: this.generalInformation.get('generalInformation_2')?.value,
              response_value: [this.generalInformation.get('generalInformationyestext_2')?.value, this.generalInformation.get('generalInformationyes_2')?.value].toString(),
            },
            {
              id: this.viewgeneralinformation[2]?.id == 0 ? 0 : this.viewgeneralinformation[2]?.id,
              category_name: 'generalInformation_3',
              is_completed: this.generalInformation.get('generalInformation_3')?.value,
              response_value: [this.generalInformation.get('generalInformationyestext_3')?.value, this.generalInformation.get('generalInformationyes_3')?.value].toString(),
            },
            {
              id: this.viewgeneralinformation[3]?.id == 0 ? 0 : this.viewgeneralinformation[3]?.id,
              category_name: 'generalInformation_4',
              is_completed: this.generalInformation.get('generalInformation_4')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[4]?.id == 0 ? 0 : this.viewgeneralinformation[4]?.id,
              category_name: 'generalInformation_5',
              is_completed: this.generalInformation.get('generalInformation_5')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[5]?.id == 0 ? 0 : this.viewgeneralinformation[5]?.id,
              category_name: 'generalInformation_6',
              is_completed: this.generalInformation.get('generalInformation_6')?.value,
              response_value: this.generalInformation.get('generalInformationyes_6')?.value,
            },
            {
              id: this.viewgeneralinformation[6]?.id == 0 ? 0 : this.viewgeneralinformation[6]?.id,
              category_name: 'generalInformation_7',
              is_completed: this.generalInformation.get('generalInformation_7')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[7]?.id == 0 ? 0 : this.viewgeneralinformation[7]?.id,
              category_name: 'generalInformation_8',
              is_completed: this.generalInformation.get('generalInformation_8')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[8]?.id == 0 ? 0 : this.viewgeneralinformation[8]?.id,
              category_name: 'generalInformation_9',
              is_completed: this.generalInformation.get('generalInformation_9')?.value,
              response_value: [this.generalInformation.get('connectedpersonname')?.value, this.generalInformation.get('relationship')?.value].toString(),
            },
            {
              id: this.viewgeneralinformation[9]?.id == 0 ? 0 : this.viewgeneralinformation[9]?.id,
              category_name: 'generalInformation_10',
              is_completed: this.generalInformation.get('generalInformation_10')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[10]?.id == 0 ? 0 : this.viewgeneralinformation[10]?.id,
              category_name: 'generalInformation_11',
              is_completed: this.generalInformation.get('generalInformation_11')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[11]?.id == 0 ? 0 : this.viewgeneralinformation[11]?.id,
              category_name: 'generalInformation_12',
              is_completed: this.generalInformation.get('generalInformation_12')?.value,
              response_value: '',
            },
            {
              id: this.viewgeneralinformation[12]?.id == 0 ? 0 : this.viewgeneralinformation[12]?.id,
              category_name: 'generalInformation_13',
              is_completed: this.generalInformation.get('generalInformation_13')?.value,
              response_value: '',
            },
          ]);

        } else if (this.currentStep === 11) {
          savenewApplication.setChecklist([
            {
              id: this.viewfitpropercriteria[0]?.id == 0 ? 0 : this.viewfitpropercriteria[0]?.id,
              category_name: 'fitPropercriteria_1',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_1')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[1]?.id == 0 ? 0 : this.viewfitpropercriteria[1]?.id,
              category_name: 'fitPropercriteria_2',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_2')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[2]?.id == 0 ? 0 : this.viewfitpropercriteria[2]?.id,
              category_name: 'fitPropercriteria_3',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_3')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[3]?.id == 0 ? 0 : this.viewfitpropercriteria[3]?.id,
              category_name: 'fitPropercriteria_4',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_4')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[4]?.id == 0 ? 0 : this.viewfitpropercriteria[4]?.id,
              category_name: 'fitPropercriteria_5',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_5')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[5]?.id == 0 ? 0 : this.viewfitpropercriteria[5]?.id,
              category_name: 'fitPropercriteria_6',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_6')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[6]?.id == 0 ? 0 : this.viewfitpropercriteria[6]?.id,
              category_name: 'fitPropercriteria_7',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_7')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[7]?.id == 0 ? 0 : this.viewfitpropercriteria[7]?.id,
              category_name: 'fitPropercriteria_8',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_8')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[8]?.id == 0 ? 0 : this.viewfitpropercriteria[8]?.id,
              category_name: 'fitPropercriteria_9',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_9')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[9]?.id == 0 ? 0 : this.viewfitpropercriteria[9]?.id,
              category_name: 'fitPropercriteria_10',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_10')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[10]?.id == 0 ? 0 : this.viewfitpropercriteria[10]?.id,
              category_name: 'fitPropercriteria_11',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_11')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[11]?.id == 0 ? 0 : this.viewfitpropercriteria[11]?.id,
              category_name: 'fitPropercriteria_12',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_12')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[12]?.id == 0 ? 0 : this.viewfitpropercriteria[12]?.id,
              category_name: 'fitPropercriteria_13',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_13')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[13]?.id == 0 ? 0 : this.viewfitpropercriteria[13]?.id,
              category_name: 'fitPropercriteria_14',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_14')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[14]?.id == 0 ? 0 : this.viewfitpropercriteria[14]?.id,
              category_name: 'fitPropercriteria_15',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_15')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[15]?.id == 0 ? 0 : this.viewfitpropercriteria[15]?.id,
              category_name: 'fitPropercriteria_16',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_16')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[16]?.id == 0 ? 0 : this.viewfitpropercriteria[16]?.id,
              category_name: 'fitPropercriteria_17',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_17')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[17]?.id == 0 ? 0 : this.viewfitpropercriteria[17]?.id,
              category_name: 'fitPropercriteria_18',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_18')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[18]?.id == 0 ? 0 : this.viewfitpropercriteria[18]?.id,
              category_name: 'fitPropercriteria_19',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_19')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[19]?.id == 0 ? 0 : this.viewfitpropercriteria[19]?.id,
              category_name: 'fitPropercriteria_20',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_20')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[20]?.id == 0 ? 0 : this.viewfitpropercriteria[20]?.id,
              category_name: 'fitPropercriteria_21',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_21')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[21]?.id == 0 ? 0 : this.viewfitpropercriteria[21]?.id,
              category_name: 'fitPropercriteria_22',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_22')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[22]?.id == 0 ? 0 : this.viewfitpropercriteria[22]?.id,
              category_name: 'fitPropercriteria_23',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_23')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[23]?.id == 0 ? 0 : this.viewfitpropercriteria[23]?.id,
              category_name: 'fitPropercriteria_24',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_24')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[24]?.id == 0 ? 0 : this.viewfitpropercriteria[24]?.id,
              category_name: 'fitPropercriteria_25',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_25')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[25]?.id == 0 ? 0 : this.viewfitpropercriteria[25]?.id,
              category_name: 'fitPropercriteria_26',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_26')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[26]?.id == 0 ? 0 : this.viewfitpropercriteria[26]?.id,
              category_name: 'fitPropercriteria_27',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_27')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[27]?.id == 0 ? 0 : this.viewfitpropercriteria[27]?.id,
              category_name: 'fitPropercriteria_28',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_28')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[28]?.id == 0 ? 0 : this.viewfitpropercriteria[28]?.id,
              category_name: 'fitPropercriteria_29',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_29')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[29]?.id == 0 ? 0 : this.viewfitpropercriteria[29]?.id,
              category_name: 'fitPropercriteria_30',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_30')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[30]?.id == 0 ? 0 : this.viewfitpropercriteria[30]?.id,
              category_name: 'fitPropercriteria_31',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_31')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[31]?.id == 0 ? 0 : this.viewfitpropercriteria[31]?.id,
              category_name: 'fitPropercriteria_32',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_32')?.value,
              response_value: '',
            },
            {
              id: this.viewfitpropercriteria[32]?.id == 0 ? 0 : this.viewfitpropercriteria[32]?.id,
              category_name: 'fitPropercriteria_33',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_33')?.value,
              response_value: this.fitandProperCriteria.get('fitPropercriteriayes_33')?.value,
            },
            {
              id: this.viewfitpropercriteria[33]?.id == 0 ? 0 : this.viewfitpropercriteria[33]?.id,
              category_name: 'fitPropercriteria_34',
              is_completed: this.fitandProperCriteria.get('fitPropercriteria_34')?.value,
              response_value: '',
            },
          ]);

          let bscGrade = String(this.fitandProperCriteria.get('quarteryear_1')?.value);
          let bscSatisfactory = String(this.fitandProperCriteria.get('gradeRepresentative')?.value);
          let bscGrade_1 = String(this.fitandProperCriteria.get('quarteryear_2')?.value);
          let bscSatisfactory_1 = String(this.fitandProperCriteria.get('gradeSupervisor')?.value);

          savenewApplication.setBscGrade(bscGrade);
          savenewApplication.setBscGrade_1(bscGrade_1);
          savenewApplication.setBscSatisfactory(bscSatisfactory);
          savenewApplication.setBscSatisfactory_1(bscSatisfactory_1);

        } else if (this.currentStep === 12) {

          savenewApplication.setComment(this.additionalDeclarations.get('details')?.value);

        } else if (this.currentStep === 13) {

        }
        this.saveApplicationDetails(savenewApplication);
      }
      this.currentStep++;
    }

    if (status[0] === 'Completed' && status[1] === 'finalsubmit') {
      if (this.currentStep === 14) {
        if (this.branchDetailsFormValid() == 'Completed' && this.personalDetailsFormValid() == 'Completed' && this.spouseDetailsFormValid() == 'Completed' && this.contactDetailsFormValid() == 'Completed' && this.bankDetailsFormValid() == 'Completed' && this.serviceCommitmentFormValid() == 'Completed' && this.academicFormValid() == 'Completed' && this.regulatoryProfessionalQualificationsFormValid() == 'Completed' && this.employmentHistoryFormValid() == 'Completed' && this.businessInterestsFormValid() == 'Completed' && this.fitandProperCriteriaFormValid() == 'Completed' && this.additionalDeclarationsFormValid() == 'Completed' && this.additionalAttachmentsFormValid() == 'Completed') {
          this.openConfirmDialog();
        } else {
          this.submitmessage = 'Complete and Save all sections before submit';
          this.declarationClausesFormValid.set('In Progress');
        }
      }
    }
  }

  async saveApplicationDetails(savenewApplication: NewRepApplication) {
    this.setSprinner.set(true);
    const responseData = await this.newRepApplicationService
      .savenewapplicationDetails(savenewApplication)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewApplication();
      if (this.finalsubmit() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        window.location.reload();
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }
      // this.router.navigate(['/agent-onboarding']);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }


  changeFullName(fullName: string): string {
    return fullName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }


  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        this.finalsubmit.set(true);
        let savenewApplication = new NewRepApplication();

        savenewApplication.setId(this.viewId);
        savenewApplication.setisAgreed(this.declarationClauses.get('declarationAccepted')?.value);
        savenewApplication.setFullName(this.declarationClauses.get('declarantName')?.value);
        savenewApplication.setDate(this.declarationClauses.get('declarationDate')?.value + 'T00:00:00Z');
        this.saveApplicationDetails(savenewApplication);
      } else {
        // console.log('User cancelled');
        this.finalsubmit.set(false);
      }
    });
  }

  async previewAttachment(fileName: string[]) {
    this.showPreview = true;
    const id = Number(fileName[0]);
    try {

      const responseData = await this.newRepApplicationService
        .previewdocuments(id);

      // Create blob URL
      const fileURL = URL.createObjectURL(responseData);

      // Safe URL
      this.selectedDocument = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      this.isPdf = fileName[1].toLowerCase().endsWith('.pdf');
      this.currentFileName = fileName[1];

    } catch (error) {
      console.error(error);
    }
    this.resetZoom();
  }


  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }

}
